import { styled } from "@mui/styles";
import { SBBox } from "modules/Commons";

export const AccordionContainer = styled(SBBox)(() => ({
	display: "flex",
	width: "100%",
	height: "100%",
}));
